import { getMemberKeys } from 'Services/WeaverUtils'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { WeaverLoading } from 'Components'
import {
  filterNodesByGraph
  filterNodesByRelation
  filterNodesByType
} from 'Services/GraphFilterUtils'

nodeSelector = createSelector((state) ->
  state.graph.graphData.nodes
, (node) -> node)

edgeSelector = createSelector((state) ->
  state.graph.graphData.edges
, (edge) -> edge)

typeSelector = createSelector((state) ->
  state.explore.typesMap
, (type) -> type)

withFilterData = (WrappedComponent, getItems, itemSelector) ->
  (props) ->
    dispatch = useDispatch()
    [items, setItems] = useState([])
    [loading, setLoading] = useState(true)

    nodes = useSelector(nodeSelector)
    edges = useSelector(edgeSelector)
    types = useSelector(typeSelector)

    if itemSelector?
      selectedItems = useSelector(itemSelector)
    else
      selectedItems = undefined

    awaitAndSetItems = ->
      setItems(
        await getItems({
          nodes,
          edges,
          memberKeys: getMemberKeys(),
          selectedItems,
          types: _.values(types)
        })
      )
      setLoading(false)

    useEffect(->
      awaitAndSetItems()
      undefined
    , [nodes])

    if loading
      <div style={{ display: 'flex', flex: '1 1 auto', alignItems: 'center', justifyContent: 'center' }}>
        <WeaverLoading style={{ width: '25%' }} />
      </div>
    else
      <WrappedComponent items={items} {props...} />

export default withFilterData
